import React from 'react'

import EditIcon from '../../Icons/EditIcon'
import styles from './styles.module.scss'

const CategoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox='0 0 332 345'
    >
      <path
        fill="#3983f7"
        d="M153.52 22.414a15 15 0 0 1 25.961 0l65.48 113.068A15 15 0 0 1 231.98 158H101.02a15 15 0 0 1-12.98-22.517Z"
      />
      <rect
        width={149}
        height={149}
        fill="#3983f7"
        rx={30}
        transform="translate(0 196)"
      />
      <circle
        cx={74.5}
        cy={74.5}
        r={74.5}
        fill="#3983f7"
        transform="translate(183 196)"
      />
    </svg>
  )
}

const CategoryCard = ({category, canEdit, onEditComment}) => {
  return (
    <div className={styles.commentCard}>
      <div className={styles.commentCard__header}>
        <CategoryIcon />
        {category.name}
      </div>
      <div className={styles.commentCard__body}>
        {
          category.value
            ? <span className={styles.commentCard__text}>
                {category.value}
              </span>
            : null
        }
        {
          Array.isArray(category.dropdown_fields)
            ? category.dropdown_fields.filter(f => f.value).map((field, i) => {
                return (
                  <div key={i} className={styles.commentCard__text}>
                    {field.name}: {field.value}
                  </div>
                )
              })
            : null
        }
        {
          canEdit
            ? <div className={styles.editButton} onClick={() => onEditComment(category)}>
                <EditIcon />
              </div>
            : null
        }
      </div>
    </div>
  );
}
export default CategoryCard
